import { Transaction } from 'dexie';
import { DBMigration } from './lessonplan.migration';
import { SCHEMAS } from './students.schema';
import { syncedDBModel } from '../models/synced';
import { fetchStudentAssessmentDataV1 } from '../api/students';
import { LOCAL_STORAGE_KEYS } from '@taleemabad/shared';
import { Region } from '@taleemabad/dsm/components';

export const studentDBMigration: DBMigration[] = [
  {
    version: 12,
    schema: SCHEMAS.v2,
    upgrade: async (transaction) => {
      if (
        (
          localStorage.getItem(
            LOCAL_STORAGE_KEYS.SELECTED_REGION,
          ) as unknown as Region
        ).label === 'Balochistan' ||
        process.env.NX_PUBLIC_BASE_URI?.includes('balochistan')
      ) {
        console.log('Skipping migration for Balochistan');
      } else {
        await clearStudentDB(transaction);
        transaction.on('complete', async () => {
          try {
            await fetchStudentAssessmentDataV1(null);
          } catch (error) {
            console.error('Failed to fetch data:', error);
          }
        });
      }
    },
  },
  {
    version: 13,
    schema: SCHEMAS.v3,
    upgrade: async (transaction) => {
      await clearStudentDB(transaction);
      transaction.on('complete', async () => {
        try {
          await fetchStudentAssessmentDataV1(null);
        } catch (error) {
          console.error('Failed to fetch data:', error);
        }
      });
    },
  },
];

const clearStudentDB = async (tx: Transaction) => {
  const deleteTables = [
    'checkpoint',
    'checkpointResults',
    'checkpointAssessments',
    'studentsDataV2',
    'studentsAssessmentData',
    'usersDataV2',
    'checkedStudentExam',
    'studentDuplicate',
    'studentSubjectAnswerAnalysis',
    'checkedStudentExamV2',
  ];
  try {
    for (const tableName of deleteTables) {
      await tx.table(tableName).clear();
    }
  } catch (error) {
    console.error('Failed during StudentDB clearing or data fetching:', error);
    syncedDBModel.resetSyncRecord();
  }
};
